import React, { useState, useEffect } from "react";
import FacebookLogin from "@greatsumini/react-facebook-login";
import { toast } from "react-toastify";
import { useNavigate, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { loginFacebook, clearRedux } from "../../redux/slices/authSlice";
import "./google-login.css";

const FacebookLoginButton = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const { user, error, authSource } = useSelector((state) => state.auth);

  useEffect(() => {
    if (user && authSource === "facebook") {
      setIsLoading(false);
      toast.success("Đăng nhập thành công");
      dispatch(clearRedux());
      navigate("/");
    }
    if (error && authSource === "facebook") {
      setIsLoading(false);
      toast.error(error);
      dispatch(clearRedux());
    }
  }, [user, error]);

  const handleLoginSuccess = (response) => {
    if (response.accessToken) {
      setIsLoading(true);
      dispatch(loginFacebook(response.accessToken));
    } else {
      toast.error("Đăng nhập Facebook thất bại!");
    }
  };

  const handleLoginFail = (error) => {
    toast.error("Đăng nhập thất bại!");
    console.error("Facebook login failed:", error);
  };

  return (
    <>
      {isLoading && (
        <div className="loading-overlay">
          <div className="spinner"></div>
        </div>
      )}

      <FacebookLogin
        appId={process.env.REACT_APP_FACEBOOK_APP_ID}
        onSuccess={handleLoginSuccess}
        onFail={handleLoginFail}
        useRedirect={false}
        render={({ onClick }) => (
          <Link
            to=""
            className="btn btn-light flex-fill d-flex align-items-center justify-content-center"
            onClick={(e) => {
              e.preventDefault();
              onClick(); // Gọi đăng nhập Facebook
            }}
          >
            <img
              src="assets/img/icons/fb-icon.svg"
              className="me-2"
              alt="Facebook Logo"
            />
            Facebook
          </Link>
        )}
      />
    </>
  );
};

export default FacebookLoginButton;
